LS.util.route({
	'consent': {
		':load': 'consent',
		':unload': 'consent:unload'
	}
});